<section class="ds-modal check-list-details-modal" aria-labelledby="check_list_details_modal_title">
    <form class="check-list-details-modal__form" [formGroup]="checkListForm" novalidate>
        <div class="check-list-details-modal__header">
            <div class="ds-modal__header check-list-details-modal__header-content">
                <h2 id="check_list_details_modal_title" class="ds-modal__title">Checklist Details</h2>
            </div>

            <ds-icon-button size="md" theme="secondary-gray" icon="close" (buttonClick)="onClose()"></ds-icon-button>
        </div>

        <div class="ds-modal__content check-list-details-modal__content">
            <div
                *ngIf="isLoading && !hasRows"
                class="check-list-details-modal__state"
                role="status"
                aria-live="polite"
                aria-label="Loading"
            >
                <mat-spinner class="progress-spinner-v2" [diameter]="spinnerDiameter"></mat-spinner>
            </div>

            <div *ngIf="hasRows" class="check-list-details-modal__table-wrapper">
                <table
                    id="viewChecklistTable"
                    mat-table
                    matSort
                    class="check-list-details-modal__table"
                    aria-label="Checklist details"
                    [dataSource]="dataSource"
                    [trackBy]="trackByItemName"
                >
                    <ng-container matColumnDef="serialNumber">
                        <th *matHeaderCellDef mat-header-cell>S.NO.</th>
                        <td *matCellDef="let row; let index = index" mat-cell>{{ index + 1 }}</td>
                    </ng-container>

                    <ng-container matColumnDef="itemName">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header sortActionDescription="Sort by item">Item</th>
                        <td *matCellDef="let row" mat-cell>{{ row.itemName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="lastUpdatedByName">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header sortActionDescription="Sort by last updated by">
                            Last Updated By
                        </th>
                        <td *matCellDef="let row" mat-cell>{{ row.lastUpdatedByName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="lastUpdatedOn">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header sortActionDescription="Sort by last updated on">
                            Last Updated On
                        </th>
                        <td *matCellDef="let row" mat-cell>{{ row.lastUpdatedOn | date: dateFormat }}</td>
                    </ng-container>

                    <ng-container matColumnDef="isChecked">
                        <th *matHeaderCellDef mat-header-cell>Completed</th>
                        <td *matCellDef="let row" mat-cell class="check-list-details-modal__completed">
                            <ds-checkbox
                                label="Completed"
                                [formControl]="row.isCheckedControl"
                                (change)="onCompletedChange(row)"
                            ></ds-checkbox>
                        </td>
                    </ng-container>

                    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
                </table>
            </div>

            <div *ngIf="!hasRows && !isLoading" class="check-list-details-modal__empty">
                <ds-icon name="checklist" size="xl" theme="secondary"></ds-icon>
                <ds-text size="lg" text="No records found" weight="semibold"></ds-text>
            </div>
        </div>

        <div class="ds-modal__footer ds-modal__footer--full-width check-list-details-modal__footer">
            <ds-button label="Cancel" size="lg" theme="secondary-gray" (buttonClick)="onClose()"></ds-button>
            <ds-button
                *ngIf="canEdit && hasRows"
                label="Save Changes"
                size="lg"
                theme="primary"
                [isLoading]="isLoading"
                [isDisabled]="isLoading || !hasPendingChanges"
                (buttonClick)="onSave()"
            ></ds-button>
        </div>
    </form>
</section>
